import { createContext } from "react";

import { ButtonProps } from "../Button";

export type SplitControlVariant = "primary" | "secondary" | "contrast";

export type SplitControlContextProps = {
  variant: SplitControlVariant;
  size?: ButtonProps["size"];
};

export const SplitControlContext = createContext<SplitControlContextProps | undefined>(undefined);
SplitControlContext.displayName = "SplitControlContext";
